import * as Yup from 'yup';

export default Yup.object().shape({
  receiverName: Yup.string().required('Naam ontvanger is verplicht'),
  receiverEmail: Yup.string()
    .email('Het ingevulde e-mailadres is niet valide')
    .required('Email ontvanger is verplicht'),
});
